import type { AchievementIcon as IconName } from '@st/contract';
import { IconDumbbell, IconFlame, IconStar, IconTarget, IconTrophy } from './icons';

/**
 * Ikona postignuca.
 *
 * Server salje znacenje (`workout`, `streak`, `record`, `goal`), klijent crta.
 * Prije je server slao emoji, pa je izgled ovisio o fontu uredaja i nikad nije
 * pripadao ostatku suceja. Nepoznato ime pada na `generic` umjesto da nestane —
 * stariji zapisi u offline bazi jos nose stari oblik.
 */
const MAP = {
  workout: IconTrophy,
  streak: IconFlame,
  record: IconDumbbell,
  goal: IconTarget,
  generic: IconStar,
} as const satisfies Record<IconName, unknown>;

export function AchievementIcon({ name, size = 22 }: { name: string; size?: number }) {
  const Cmp = MAP[name as IconName] ?? IconStar;
  return <Cmp width={size} height={size} aria-hidden="true" />;
}
